import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

const PRESETS = [
  { label: "Réveillon", start: "2026-12-28", end: "2027-01-02" },
  { label: "Carnaval", start: "2027-02-05", end: "2027-02-10" },
  { label: "Feriado", start: "", end: "" },
];

const newKey = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`;
export const withKeys = (seasons) => seasons.map((s) => (s._key ? s : { ...s, _key: newKey() }));

export const SeasonPricesEditor = ({ seasons, onChange, basePrice }) => {
  const update = (i, patch) => onChange(seasons.map((s, j) => (j === i ? { ...s, ...patch } : s)));
  const add = (preset) => onChange([...seasons, { ...preset, price: basePrice || "", _key: newKey() }]);

  return (
    <div data-testid="season-editor">
      <label className="text-[11px] font-bold uppercase tracking-wide text-slate-500">Preço por temporada (diária fixa no período)</label>
      <div className="space-y-2 mt-1">
        {seasons.map((s, i) => (
          <div key={s._key || i} className="grid grid-cols-12 gap-1.5 items-center bg-white border border-slate-200 rounded-lg p-2" data-testid={`season-row-${i}`}>
            <Input value={s.label} onChange={(e) => update(i, { label: e.target.value })} placeholder="Nome"
              className="col-span-12 sm:col-span-3 h-8 bg-white border-slate-200 text-xs" data-testid={`season-label-${i}`} />
            <Input type="date" value={s.start} onChange={(e) => update(i, { start: e.target.value })}
              className="col-span-5 sm:col-span-3 h-8 bg-white border-slate-200 text-xs" data-testid={`season-start-${i}`} />
            <Input type="date" value={s.end} min={s.start} onChange={(e) => update(i, { end: e.target.value })}
              className="col-span-5 sm:col-span-3 h-8 bg-white border-slate-200 text-xs" data-testid={`season-end-${i}`} />
            <Input type="number" value={s.price} onChange={(e) => update(i, { price: e.target.value })} placeholder="R$"
              className="col-span-10 sm:col-span-2 h-8 bg-white border-slate-200 text-xs" data-testid={`season-price-${i}`} />
            <button type="button" onClick={() => onChange(seasons.filter((_, j) => j !== i))}
              className="col-span-2 sm:col-span-1 text-slate-500 hover:text-red-600 flex justify-center" data-testid={`season-remove-${i}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        <div className="flex flex-wrap gap-1.5">
          {PRESETS.map((p) => (
            <button key={p.label} type="button" onClick={() => add(p)}
              className="text-[11px] font-bold px-2.5 py-1 rounded-full border border-slate-200 text-slate-600 hover:border-amber-400 hover:bg-amber-50 hover:text-amber-700 flex items-center gap-1"
              data-testid={`season-add-${p.label.toLowerCase()}`}>
              <Plus size={11} /> {p.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export const cleanSeasons = (seasons) =>
  seasons
    .filter((s) => s.start && s.end && Number(s.price) > 0)
    .map((s) => ({ label: s.label || "Temporada", start: s.start, end: s.end < s.start ? s.start : s.end, price: Number(s.price) }));
